import FsOverview from './views/fs-overview/fs-overview'
import FairView from './views/fs-fair-view/fs-fair-view'
import FsReports from './views/fs-report-view/fs-report-view'
import FsHelpView from './views/fs-help-view/fs-help-view'
import { FsRoute, Module, StaticView } from './shared/model'
import FsETLView from './views/fs-etl-view/fs-etl-view'

const slug = process.env.REACT_APP_SLUG

const TestingFsRoutes: FsRoute[] = []

const FsRoutes: FsRoute[] = [
  {
    path: '/fs/dashboard',
    name: StaticView.DASHBOARD,
    index: true,
    component: <FsOverview />,
  },
  {
    path: '/fs/fair-pay/:id',
    name: Module.PAY,
    component: <FairView />,
  },
  {
    path: '/fs/fair-career/:id',
    name: Module.CAREER,
    component: <FairView />,
  },
  {
    path: '/fs/fair-working_time/:id',
    name: Module.WORKING_TIME,
    component: <FairView />,
  },
  {
    path: '/fs/fair-training/:id',
    name: Module.TRAINING,
    component: <FairView />,
  },
  {
    path: '/fs/reports',
    name: StaticView.REPORTS,
    component: <FsReports />,
  },
  {
    path: '/fs/help',
    name: StaticView.HELP,
    component: <FsHelpView />,
  },
  {
    path: '/fs/etl',
    name: StaticView.ETL,
    component: <FsETLView />,
  },
]

export default slug === 'stagingaws' ? [...FsRoutes, ...TestingFsRoutes] : FsRoutes
